import React from 'react';

function CustomColorSet(props) {
  const price = Number(props.price / 100).toFixed(2);
  return (
    <React.Fragment>
      {props.children.length ? (
        <section className="custom-colorset">
          <h2>Tavā komplektā ietilpst:</h2>
          <div className="custom-colorset__color-list">
            {props.children}
          </div>
          <p className="custom-colorset__price">Komplekta cena:&nbsp;
            <span>{price} &euro;</span>
          </p>
        </section>
      ) : (
        <section className="custom-colorset custom-colorset--empty">
          <h2>Tavā komplektā vēl nav<br />nevienas krāsas.<br />Droši izvēlies!</h2>
        </section>
      )}
    </React.Fragment>
  );
}

export default CustomColorSet;



// WEBPACK FOOTER //
// ./src/components/customColorSet.js